import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { Router } from 'react-router-dom';
import history from 'utils/history';
import 'i18n';
import * as serviceWorker from 'serviceWorker';
import reduxStore from 'stores/store';

import App from 'containers/App/App';

ReactDOM.render(
    <Provider store={reduxStore}>
        <Router history={history} >
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();